import * as React from "react";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkExpandoPeek } from "uitk-react-expando";
import { AnalyticsConfig } from "uitk-react-utils";

import { withStores } from "stores";
import { Action, FlexTrackingInfo, sendDelayedTrackEvent } from "components/utility/analytics/FlexAnalyticsUtils";

import { DestinationDescriptionProps } from "./typings";
import { DestinationDescriptionFlexModuleResult } from "typings/microserviceModels/destination-description-flex-module";
import { observer } from "mobx-react";

// These values are a starting point for mobile and desktop,
// and are pulled from the new Figma design.
export const SMALL_COLLAPSE_HEIGHT = 120;
export const MEDIUM_COLLAPSE_HEIGHT = 280;

const DestinationDescription = withStores(
  "analytics",
  "context",
  "flexModuleModelStore"
)(
  observer((props: DestinationDescriptionProps) => {
    const { flexTemplateNode, flexModuleModelStore } = props;
    const { id, options } = flexTemplateNode;
    const model = flexModuleModelStore.getModel(id) as DestinationDescriptionFlexModuleResult | null;

    if (!model) {
      return null;
    }

    const { content } = model;
    const { formatText } = useLocalization();

    // This is covered in e2e test
    /* istanbul ignore next */
    const analytics: AnalyticsConfig = {
      id: "TG.LP.Dest.Description",
      callback: (moduleId) => {
        const flexTrackingInfo: FlexTrackingInfo = {
          moduleName: moduleId,
          action: Action.CLICK,
        };
        sendDelayedTrackEvent(flexTrackingInfo, props.analytics);
      },
    };

    const { teaser, body } = content;

    const teaserText = Boolean(teaser?.length) && (
      <p className="uitk-cell uitk-type-400 all-b-margin-three uitk-type-medium" role="heading" aria-level={2}>
        {teaser.join("")}
      </p>
    );

    const descriptionText = (thresholdHeight: number) =>
      Boolean(body?.length) && (
        <UitkExpandoPeek
          collapseHeight={thresholdHeight}
          collapseLabel={formatText("read.less.label")}
          expandLabel={formatText("read.more.label")}
          threshold={thresholdHeight}
          analytics={analytics}
        >
          {body.map((line: string, moduleId: number) => {
            const description = line.replace("<p>", "").replace("</p>", "");

            return <p key={`destination-description-body-${moduleId}`}>{description}</p>;
          })}
        </UitkExpandoPeek>
      );

    const descriptionView = (thresholdHeight: number) => (
      <article>
        {teaserText}
        {descriptionText(thresholdHeight)}
      </article>
    );

    return (
      <div id={id} data-fm={options.fmId} className="DestinationDescription uitk-cell all-cell-1-1 uitk-type-300">
        <Viewport>
          <ViewSmall>{descriptionView(SMALL_COLLAPSE_HEIGHT)}</ViewSmall>
          <ViewMedium>{descriptionView(MEDIUM_COLLAPSE_HEIGHT)}</ViewMedium>
        </Viewport>
      </div>
    );
  })
);

export default DestinationDescription;
